var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}]},[_c('h1',[_vm._v(_vm._s(_vm.titulo))]),_c('div',{attrs:{"id":"faq-id"},domProps:{"innerHTML":_vm._s(_vm.innetData)}})]),(_vm.loading)?_c('div',{staticClass:"ufv-menu-loading d-flex justify-center"},[_c('spinner')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }